import React from 'react';
import ProductImage from '../ProductImage';

function ProductThumbnail({ product, size = 40 }) {
  return <ProductImage product={product} width={size} height={Math.round(size * 4 / 3)} zoom />;
}

export default ProductThumbnail;
